import { TimeLineAction } from '../../../generated/graphql'

/**
 * Single list of timeline actions hidden from event-type filters and omitted from
 * “show all” profile timeline queries (noisy, redundant, or shown elsewhere — e.g. co-rank card).
 */
export const TIMELINE_EXCLUDED_EVENT_TYPES = [
  TimeLineAction.ContributionCancelled,
  TimeLineAction.ContributionBumpCancelled,
  TimeLineAction.ClusterDeleted,
  TimeLineAction.NodeDeleted,
  TimeLineAction.CorankUpdated,
] as const satisfies readonly TimeLineAction[]

/** Every `TimeLineAction` not listed in `TIMELINE_EXCLUDED_EVENT_TYPES` (dropdown + “all actions” queries). */
export function timelineActionsAvailableForFilters(): TimeLineAction[] {
  const excluded = new Set<string>(TIMELINE_EXCLUDED_EVENT_TYPES)
  return Object.values(TimeLineAction).filter(
    (action): action is TimeLineAction =>
      typeof action === 'string' && !excluded.has(action)
  )
}
